/**
 * Page shell — SPEC §12.1.
 *
 * The logo is the horizontal lockup, which already contains the wordmark, so it is not
 * paired with a redundant "GEAR UP with CPR" text title.
 */

import type { ReactNode } from 'react';
import { useSession } from '../lib/session.js';
import logo from '../assets/logo.png';

export function Shell({ children }: { children: ReactNode }) {
  const { instructor, signOut } = useSession();

  return (
    <div className="shell">
      <header className="shell__header">
        <img className="shell__logo" src={logo} alt="GEAR UP with CPR" />
        {instructor && (
          <div className="row">
            <span className="small muted">Hi {instructor.firstName}</span>
            <button className="btn btn--ghost" onClick={() => void signOut()}>
              Sign out
            </button>
          </div>
        )}
      </header>

      <main className="shell__main">{children}</main>

      <footer className="shell__footer">
        GEAR UP with CPR · Instructor availability
      </footer>
    </div>
  );
}
